import * as React from "react";
import {
  Img,
  Heading,
  Link,
  Row,
  Section,
  Text,
} from "@react-email/components";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";

export const name = "EventCreated";
export const subject = "{{event_name}} is live!";

export function template(props: {
  event_name: string;
  event_url: string;
  dashboard_url: string;
  cdn_url: string;
  event_image: string;
}) {
  return (
    <Layout language="en" title={`${props.event_name} is live. `}>
      <Header src={`${props.cdn_url}/system/kyd-logo-email.png`} />
      <Heading as="h1" style={{ fontSize: "30px" }}>
        Congrats! {props.event_name} was created!
      </Heading>
      <Img width={"100%"} src={props.event_image} />
      <Heading as="h2" style={{ fontSize: "30px" }}>
        View your event and dashboard below!
      </Heading>
      <Section>
        <Row>
          <Text style={bodyText}>
            ✂️ Here are your event links for you easily to copy and paste!
          </Text>
        </Row>
        <Row>
          <Text style={bodyText}>
            🎟️ Event link:{" "}
            <Link href={props.event_url}>Click to go to event</Link>
          </Text>
        </Row>
        <Row>
          <Text style={bodyText}>
            📈Dashboard:{" "}
            <Link href={"https://dashboard.kydlabs.com"}>
              Click to go to dashboard
            </Link>
          </Text>
        </Row>
        <Row>
          <Text style={{ ...bodyText, fontStyle: "italic" }}>
            For new customers, please login to your dashboard using your phone
            number!
          </Text>
        </Row>
      </Section>
      <Footer cdn_url={props.cdn_url} />
    </Layout>
  );
}

const bodyText = {
  fontSize: "18px",
  lineHeight: "22px",
};

template.PreviewProps = {
  event_name: "Test event",
  event_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/cart?cko-session-id=sid_p5bnqz263kvevpy4ibb7kgrcye",
  dashboard_url:
    "https://coachella.kydlabsdemo.com/manager/events/EV2f1de93f-17d7-4881-a2ff-c083c580dbdc",
};

export default template;
